import { Tabs, Box, Typography, Divider, MenuItem, Menu } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import "../../styles/interactionDetailsPage.css";
import ActionItemsPage from "./ActionItemsPage";
import UserInteractionsService from "../../services/interactions/Interactions";
import { ActionItemSelectedType } from "../../utils/types";
import { GlobalContext } from "../../context/GlobalContext";
import AddIcon from '@mui/icons-material/Add';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import BulkTasksIcon from "../../assets/interaction-detail-page/bulk-tasks-icon.svg";

interface InteractionActionItemsProps {
  interactionId: string;
  interactionDetails: any | null;
  isInteractionAttendee: boolean;
  assetId: any;
}
const InteractionActionItems = ({
  interactionId,
  interactionDetails,
  isInteractionAttendee,
  assetId,
}: InteractionActionItemsProps) => {
  const [activeTab, setActiveTab] = useState<string>("by-action-items");
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [isNewActionItem, setIsNewActionItem] = useState<boolean>(false);
  const [hasGroupedByTopics, setHasGroupedByTopics] = useState<boolean>(false);
  const handleTabChange = (_event: React.SyntheticEvent, newValue: string) => {
    setActiveTab(newValue);
  };
  const [activeUsers, setActiveUsers] = useState<any[]>([]);
  const [selectedType, setSelectedType] = useState<ActionItemSelectedType>(
    "external"
  );
  const [externalCount, setExternalCount] = useState(0);
  const [internalCount, setInternalCount] = useState(0);
  const { impersonationDetails } = useContext(GlobalContext);
  const isImpersonating = impersonationDetails?.isImpersonating === true;
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const openMenu = Boolean(anchorEl);
  const [bulkTasks, setBulkTasks] = useState<boolean>(false);
  const prevOpenDialogRef = useRef(openDialog);
   const {
      isSuccess,
      isLoading: isActiveUsersLoading,
      isFetching: isActiveUsersFetching,
      isError,
      error,
      data: activeUsersData,
    } = UserInteractionsService.useGetActiveUsers( {}, true );
  
  
    useEffect(() => {
      if(isSuccess) {
        const activeUsers = activeUsersData?.data?.data || [];
        setActiveUsers(activeUsers);
      }
      if (isError) {
        console.error("error", `Error fetching active users: ${error}`);
      }
    }, [isError, error, activeUsersData, isSuccess, isActiveUsersLoading, isActiveUsersFetching]);

  useEffect(() => {
    if (prevOpenDialogRef.current && !openDialog) {
      setSelectedType("internal");
    }
    prevOpenDialogRef.current = openDialog;
  }, [openDialog]);
  return (
    <div className="action__items__parent">
      {/* header */}
      <div className="action__items__header">
        <Typography variant="body1" className="tasks__title" sx={{paddingBottom: "0px"}}>
          Recommended Tasks{" "}
          {hasGroupedByTopics && (
            <>
              - <span className="tasks__title_sub_topic">Grouped by Topics</span>
            </>
          )}
        </Typography>

        <Divider orientation="vertical" sx={{border: "1px solid #7A7A8C", height: "22px"}}/>
        <Box className="action-item-type-button">
          <button
            className={`btn-idp ${selectedType === "external" ? "active-btn" : ""}`}
            onClick={() => setSelectedType("external")}
          >
            External [{externalCount}]
          </button>

          <button
            className={`btn-idp ${selectedType === "internal" ? "active-btn" : ""}`}
            onClick={() => setSelectedType("internal")}
          >
            Internal [{internalCount}]
          </button>
        </Box>

        <div>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            className="app-tabs-container"
          >
          </Tabs>
        </div>
        <div className="action__items__header__right">
          {isInteractionAttendee && !isImpersonating && (
            <Box className="action-item-add-button">
              <Box
                className="action-item-add-button-box"
                onClick={() => {
                  setOpenDialog(true);
                  setIsNewActionItem(true);
                  setBulkTasks(false);
                }}
              >
                <AddIcon sx={{ width: 20, height: 20, color: "#FFFFFF"}} />
                <span className="action-item-add-button-text">Add Task</span>
              </Box>
              <Box
                className={`action-item-expand-button-box ${openMenu ? "active" : ""}`}
                onClick={(event: React.MouseEvent<HTMLDivElement>) => {
                  setAnchorEl(openMenu ? null : event.currentTarget);
                }}
              >
                {openMenu ? (
                  <ExpandLessIcon
                    sx={{ width: 20, height: 20, color: "#EFEBFB" }}
                  />
                ) : (
                  <ExpandMoreIcon
                    sx={{ width: 20, height: 20, color: "#EFEBFB" }}
                  />
                )}
              </Box>
              <Menu
                anchorEl={anchorEl}
                open={openMenu}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                MenuListProps={{
                  sx: {
                    padding: "0px !important",
                  },
                }}
                PaperProps={{
                  sx: {
                    borderRadius: "8px",
                    mt: 2,
                  },
                }}
              >
                <MenuItem
                  className="bulk-tasks-option"
                  onClick={() => {
                    setAnchorEl(null);
                    setOpenDialog(true);
                    setBulkTasks(true);
                    setIsNewActionItem(true);
                  }}
                >
                  <img src={BulkTasksIcon} alt="Bulk Tasks"/>
                  Add Bulk Tasks
                </MenuItem>
              </Menu>
            </Box>
          )}
        </div>
      </div>

      {/* content */}
      <div className="action__items__content">
        {activeTab === "by-action-items" && (
          <Box>
            <ActionItemsPage
              id={interactionId}
              meetingDate={interactionDetails?.startTime}
              attendees={interactionDetails?.attendedParticipants}
              interactionDetails={interactionDetails}
              setOpenDialog={setOpenDialog}
              openDialog={openDialog}
              setIsNewActionItem={setIsNewActionItem}
              isNewActionItem={isNewActionItem}
              activeUsers={activeUsers}
              assetId={assetId}
              onGroupingPresenceChange={setHasGroupedByTopics}
              selectedType={selectedType}
              onCountChange={(external, internal) => {
                setExternalCount(external);
                setInternalCount(internal);
                if (external === 0 && internal > 0) {
                  setSelectedType("internal");
                }
              }}
              bulkTasks={bulkTasks}
              setBulkTasks={setBulkTasks}
            />
          </Box>
        )}
        {activeTab === "by-topics" && (
          <Box sx={{ p: 2 }}>
            {/* Placeholder content for "By Topics" */}
            <div>Placeholder: By Topics content</div>
          </Box>
        )}
      </div>
    </div>
  );
};

export default InteractionActionItems;
